import {inject, Injectable, signal} from '@angular/core';
import {HeaderService} from '../../service/headers/header.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {Profile} from '../../interface/profile/profile.interface';
import {map, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LayoutStore {
  private  tabService = inject(HeaderService)
  readonly layout = toSignal( this.tabService.getTabs().pipe(
    catchError(()=>of(null)),
    ), { initialValue: null } );
  readonly profileInfo = toSignal<Profile | null>(
    this.tabService.getBaseInfoProfile().pipe(
      catchError(()=>of(null)),
      map(response => {
        const person = response?.data?.person;
        if (!person) {
          return null;
        }
        return {
          person: {
            id: person.id ?? null,
            name: {
              first: person.name.first ?? null,
              last: person.name.last ?? null,
              middle: person.name.middle ?? null,
            },
          },
        } satisfies Profile;
      })
    )
    ,
    { initialValue: null }
  );
  readonly tabs = signal<any>({});
}




